<!-- eslint-disable -->
<template lang="pug">
    .room(:style='roomStyle')
        img.detective__background(
            :class=`{
                  'detective__background--blured' : items.includes('eighthLetter') && !isNameUnraveled,
                  'detective__background_fullscreen': isMobile
            }`,
            :style='roomStyle',
            :src='backgroundImg'
        )
        transition(name='blur')
            moriarti(
                v-if="items.includes('eighthLetter') && !isNameUnraveled && !isFirstTime && !showVideo",
                @rightAnswer='showVideo = true'
            )
        transition(name='blur')
            .player_box(v-show='showVideo')
                #vimeo_player.player
</template>

<script>
    /*eslint-disable*/
    import Moriarti from '../Moriarti.vue';

    export default {
        props: {
            items: Array,
            sceneName: {
                type: String,
                default: 'firstLetter'
            },
            isMobile: Boolean,
            isNameUnraveled: Boolean,
            isFirstTime: Boolean,
        },
        data () {
            return {
                showVideo: false,
            }
        },
        computed: {
            roomHeight () {
                if (this.isMobile || this.isFullScreen) {
                    return '100vh';
                }
                return 'calc(100vh - 60px)';
            },
            roomStyle () {
                let width = '100%';
                let height = this.roomHeight;
                return {width: width, height: height};
            },
            backgroundImg () {
                switch (this.sceneName) {
                    case 'firstLetter':
                    case 'secondLetter':
                        return require('../../../../assets/images/detective/chapter_2/background/background_1.png');
                    case 'thirdLetter':
                    case 'fourthLetter':
                        return require('../../../../assets/images/detective/chapter_2/background/background_2.png');
                    case 'fifthLetter':
                    case 'sixthLetter':
                        return require('../../../../assets/images/detective/chapter_2/background/background_3.png');
                    case 'seventhLetter':
                    case 'eighthLetter':
                        return require('../../../../assets/images/detective/chapter_2/background/background_4.png');
                }
            },
        },
        watch: {
            showVideo: function (value) {
                value && this.loadVimeoPlayer();
            }
        },
        mounted() {
            let vimeoScript = document.createElement('script')
            vimeoScript.setAttribute('src', 'https://player.vimeo.com/api/player.js')
            document.head.appendChild(vimeoScript);
        },
        methods: {
            loadVimeoPlayer() {
                let options = {
                    id: 355327187,
                    controls: false,
                    title: false,
                    autoplay: true,
                    responsive: true
                };
                let vimeo_player = new window.Vimeo.Player('vimeo_player', options);
                vimeo_player.on("ended", this.onPlayerEnded)
            },
            onPlayerEnded() {
                this.showVideo = false;
                this.$emit('rightAnswer');
            }
        },
        components: {
            Moriarti
        }
    }
</script>

<style scoped lang="scss">
    .player_box {
        position: relative;
        display: flex;
        justify-content: center;
        height: calc(100vh - 60px);
        width: 100%;
        z-index: 2;
        background-color: white;
        overflow: hidden;
        border-radius: 40px;
        @media screen and (max-width: 568px) {
            border-radius: 0;
        }
    }

    .player {
        width: 92.65%;
    }

    .static-page {
        display: flex;
        justify-content: center;
    }

    .room {
        display: flex;
        justify-content: center;
    }

    .detective__background {
        position: absolute;
        border-radius: 40px;
        &_fullscreen {
            border-radius: 0;
        }
    }

    .detective__background--blured {
        filter: blur(8px);
    }

    .blur-enter-active, .blur-leave-active {
        transition: filter 1s, opacity 1s;
    }
    .blur-enter, .blur-leave-to {
        opacity: 0;
        filter: blur(10px);
    }
</style>
